<template>
  <el-dialog :visible.sync="dialogVisible"
             :show-close="false"
             :close-on-press-escape="false"
             :close-on-click-modal="false"
             width="800px" class="TheOrderView">
    <div slot="title" class="dialog-header">
      <div class="header-title">
        <span class="title">{{ $lang('退换货') }}</span><i></i>
        <span class="status">{{ statusTitle }}</span>
      </div>
      <img class="dialog-close" src="@/assets/images/close.png" alt="关闭" @click="onClose()">
    </div>
    <div class="dialog-main">
      <div class="d-flex flex-row">
        <the-cell :label="$lang('订单号')" :value="rowData.omsOrderThirdExtVO.orderId"/>
        <the-cell :label="$lang('运单编号')" :value="rowData.waybillId || '--'" style="margin-left: 16px;"/>
        <the-cell :label="$lang('下单时间')" :value="rowData.inputTime" style="margin-left: 16px;"/>
      </div>
      <div class="sender-info d-flex flex-row flex-nowrap">
        <div class="sender">{{ $lang('寄方') }}</div>
        <div class="info">
          <div style="margin-bottom: 8px;">
            <span class="name">{{ rowData.senderName }}</span>
            <!-- <span class="phone">{{ rowData.senderMobilePhone }}</span> -->
            <span class="phone" v-mask="{data: {...rowData,apiType:1},  key: 'senderMobilePhone', type: 'orderPlaintext' }" ></span>
          </div>
          <p class="address">{{ rowData.senderProvinceName }}{{
              rowData.senderCityName
            }}{{countryId === 1 && rowData.senderAreaName ? rowData.senderAreaName : ''}}{{ rowData.senderStreet !== undefined && rowData.senderStreet !== null ? rowData.senderStreet : '' }}{{ rowData.senderDetailedAddress }}
            {{countryId === 1 && rowData.senderShortAddress ? rowData.senderShortAddress : ''}}
            {{countryId === 1 && rowData.senderReferenceNumber ? rowData.senderReferenceNumber : ''}}
            {{countryId === 1 && rowData.senderBuildingNumber ? rowData.senderBuildingNumbe : ''}}
          </p>
        </div>
      </div>
      <div class="receive-info d-flex flex-row flex-nowrap">
        <div class="sender">{{ $lang('收方') }}</div>
        <div class="info">
          <div style="margin-bottom: 8px;">
            <span class="name">{{ rowData.receiverName }}</span>
            <!-- <span class="phone">{{ rowData.receiverMobilePhone }}</span> -->
            <span class="phone" v-mask="{data: {...rowData,apiType:2},  key: 'receiverMobilePhone', type: 'orderPlaintext' }" ></span>
          </div>
          <p class="address">{{ rowData.receiverProvinceName }}{{
              rowData.receiverCityName
            }}{{countryId === 1 && rowData.receiverAreaName ? rowData.receiverAreaName : ''}}{{ rowData.receiverStreet !== undefined && rowData.receiverStreet !== null ? rowData.receiverStreet : '' }}{{ rowData.receiverDetailedAddress }}
            {{countryId === 1 && rowData.receiverShortAddress ? rowData.receiverShortAddress : ''}}
            {{countryId === 1 && rowData.receiverReferenceNumber ? rowData.receiverReferenceNumber : ''}}
            {{countryId === 1 && rowData.receiverBuildingNumber ? rowData.receiverBuildingNumber : ''}}
          </p>
        </div>
      </div>

      <div class="grid">
        <the-cell :label="$lang('件数')" :value="rowData.packageNumber" class="cell"/>
        <the-cell :label="$lang('物品类型')" :value="rowData.goodsTypeName" class="cell"/>
        <the-cell :label="$lang('物品名称')" :value="rowData.goodsName" class="cell"/>
        <the-cell :label="$lang('物品重量')" :value="rowData.packageTotalWeight" class="cell"/>
        <the-cell :label="$lang('平台')" :value="rowData.platformName" class="cell"/>
        <the-cell :label="$lang('客户账号')" :value="rowData.customerAccount" class="cell"/>
        <the-cell :label="$lang('产品类型')" :value="rowData.expressTypeName" class="cell"/>
        <the-cell :label="$lang('支付方式')" :value="rowData.paidModeName" class="cell"/>
        <the-cell :label="$lang('代收货款币别')" :value="rowData.codCurrencyTypeName" class="cell"/>
        <the-cell :label="$lang('代收货款金额')" :value="rowData.codMoney" class="cell"/>
        <the-cell :label="$lang('代收货款手续费')" :value="rowData.codFee" class="cell"/>
        <the-cell :label="$lang('是否允许客户开箱验视')" :value="rowData.isUnpackEnabled ? $lang('是') : $lang('否')" class="cell"/>
        <the-cell :label="$lang('是否购买赔偿上限服务')" :value="rowData.insured === 1? $lang('是') : $lang('否')" class="cell"/>
        <the-cell :label="$lang('货物价值')" :value="rowData.declaredValue" class="cell"/>
        <the-cell :label="$lang('赔偿上限服务费')" :value="rowData.insuredValue" class="cell"/>
        <the-cell :label="$lang('取消原因')" :value="rowData.cancelExplain? rowData.cancelExplain:rowData.cancelReason" class="cell"/>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import TheCell from '@/views/return-exchange/components/TheCell'

export default {
  name: 'TheReturnExchangeView',
  components: { TheCell },
  props: {
    dialogVisible: {
      type: Boolean,
      default: false,
    },
    rowData: {
      type: Object,
      default: () => {
        return {}
      },
    }
  },
  data() {
    return {
      statusTitle: '',
    }
  },
  watch: {
    rowData: {
      deep: true,
      handler(newVal, oldVal) {
        // console.log(this.rowData.waybillStatusCode)
        // if (this.bulletTitle === 1) { // 如果是订单详情
        // 订单：(100, "未调派; 101, "已调派网点"; 102, "已调派业务员"; 103, "已取件";  104, "已取消";105, "取件失败")
        switch (Number(this.rowData.orderStatusCode)) {
          case 100:
            this.statusTitle = this.$lang('待取件')
            break
          case 101:
            this.statusTitle = this.$lang('待取件')
            break
          case 102:
            this.statusTitle = this.$lang('待取件')
            break
          case 103:
            this.statusTitle = this.$lang('已取件')
            break
          case 104:
            this.statusTitle = this.$lang('已取消')
            break
        }
        // } else if (this.bulletTitle === 2) { // 如果是运单详情
        //   // (201:已收件，202：已发件，203：运输中，204：派送中，205：已签收，206：退件中，207：已退件)
        //   const params = [this.rowData.waybillNo || '']
        //   switch (Number(this.rowData.waybillStatusCode)) {
        //     case 201:
        //       this.statusTitle = this.$lang('已揽件')
        //       break
        //     case 202:
        //       this.statusTitle = this.$lang('已发件')
        //       break
        //     case 203:
        //       this.statusTitle = this.$lang('运送中')
        //       break
        //     case 204:
        //       this.statusTitle = this.$lang('派件中')
        //       break
        //     case 205:
        //       this.statusTitle = this.$lang('已签收')
        //       break
        //     case 206:
        //       this.statusTitle = this.$lang('退件中')
        //       break
        //     case 207:
        //       this.statusTitle = this.$lang('已退件')
        //       break
        //     case 208:
        //       this.statusTitle = this.$lang('已拒收')
        //       break
        //   }
        //   this.getDetailByWaybillNo(params)
        // }
      },
    },
  },
  computed: {
    countryId() {
      return this.$store.state.base.user.countryId || ''
    }
  },
  methods: {
    onClose() {
      this.$emit('update:dialogVisible', false)
    }
  }
}
</script>

<style lang="scss" scoped>
.TheOrderView {
  .dialog-header {
    display: flex;
    justify-content: space-between;
    align-items: center;

    .header-title {
      display: flex;
      justify-content: flex-start;
      align-items: center;

      .title {
        font-size: 24px;
        font-family: PingFangSC-Medium, PingFangSC;
        color: rgba(51, 51, 51, 1);
        line-height: 16px;
        font-weight: 600;
      }

      i {
        display: inline-block;
        border-radius: 50%;
        overflow: hidden;
        width: 8px;
        height: 8px;
        background: #fa8b14;
        margin-left: 16px;
        margin-right: 8px;
      }

      .status {
        height: 12px;
        font-size: 12px;
        font-family: PingFangSC-Regular, PingFangSC;
        font-weight: 400;
        color: rgba(102, 102, 102, 1);
        line-height: 12px;
      }
    }

    .dialog-close {
      width: 16px;
      height: 16px;
      display: inline-block;
      cursor: pointer;
    }
  }

  .dialog-main {

    .sender-info, .receive-info {
      padding: 16px 0;

      .sender {
        width: 48px;
        height: 48px;
        background: #e60012;
        display: inline-block;
        border-radius: 50%;
        overflow: hidden;
        font-size: 12px;
        font-family: PingFangSC-Regular, PingFangSC;
        font-weight: 400;
        color: #fff;
        line-height: 48px;
        text-align: center;
      }

      .info {
        margin-left: 24px;
        flex: 1;
        -webkit-box-flex: 1;
        -ms-flex: 1;

        .name {
          max-width: 180px;
          font-size: 16px;
          font-family: PingFangSC-Regular, PingFangSC;
          color: #333333;
          font-weight: 600;
        }

        .phone, address {
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFangSC;
          font-weight: 400;
          color: #333333;
          margin-left: 24px;
        }

        .phone {
          color: #333333;
          margin-left: 24px;
        }

        .address {
          color: #666666;
        }
      }
    }

    .receive-info {
      .sender {
        background: #fff;
        color: #E60012;
        border: 1px solid #e60012;
      }
    }
  }
}

.grid {
  margin-top: 24px;
  display: grid;
  grid-template-columns: repeat(3, 33.33%);

  .cell {
    margin-bottom: 24px;
  }
}
</style>
